var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{staticClass:"mt-5",attrs:{"outlined":"","shaped":"","rows":"5","label":"label"},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }